<template>
    <div class="the-document-shelf">
        <header class="header">
            <span class="header__large-title">{{ shelf.typeName }}</span>
            <span class="header__full-title">{{ shelf.typeName }}</span>
        </header>

        <ul class="docs">
            <li v-for="doc in shelf.catalogs" :key="doc.id" class="doc">
                <router-link :to="{ name: '文档详情', query: { docId: doc.id } }">{{ doc.title }}</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'TheDocumentShelf',

    props: {
        shelf: {
            type: Object,
            default: () => ({})
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~@isyscore/styles/variables';

.the-document-shelf {
    width: 270px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(73, 120, 177, 0.15);
    border-radius: 4px;
    overflow: hidden;

    $header-background: 1 #0055ff, 2 #0078ff, 3 #3796ff, 4 #82b4ff;
    @each $index, $color in $header-background {
        &:nth-child(4n + #{ $index }) .header {
            background: $color;
        }
    }
}

.header {
    position: relative;
    height: 74px;
    line-height: 1;

    &__large-title {
        position: absolute;
        left: 90px;
        bottom: 0;
        width: 178px;
        font-size: 45px;
        font-weight: 800;
        color: rgba(255, 255, 255, 0.14);
        white-space: nowrap;
    }

    &__full-title {
        position: absolute;
        left: 30px;
        bottom: 0;
        font-size: 24px;
        font-weight: 600;
        color: #ffffff;
    }
}

.docs {
    padding: 30px;
}

.doc {
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #f2f2f2;
    list-style: disc inside;
    color: #999;

    &:last-child {
        margin-bottom: 0;
    }

    a {
        color: #666666;
        font-size: 16px;
        line-height: 22px;
        font-weight: 400;

        &:hover {
            color: $app-primary-color;
        }
    }
}
</style>
